import "./input.css?__remix_sideEffect__";
import React, { useEffect, useRef, useState } from "react";
import useStateRef from "react-usestateref";
import ArrowLeft from "../../../assets/svgs/arrow-left.svg";
import { useTutor } from "../../../context/AiTutorContext";
import {
  isEmptyOrNull,
  tutorString,
  urlString } from
"../../../utils/common-utils";
import SubmitImg from "../../../assets/ai-tutor/submit.svg";
import MenuIcon from "../../../assets/bottom-nav/menuNavbar.svg";
import MenuBoard from "../../../components/atoms/icons/menuBoard.svg";
import Formula from "../../../assets/bottom-nav/formula.svg";
import AddChapter from "../../../assets/bottom-nav/addChapter.svg";
import AddTopic from "../../../assets/bottom-nav/addTopic.svg";
import { useRoot } from "../../../context/RootContext";
import { useLocation, useNavigate } from "@remix-run/react";
import { isNotEmptyOrNull } from "../../../utils/common-utils";
import {
  BOTTOM_BUTTONS,
  getConcludeBtnText } from
"../../../utils/TutorConstants";
import {
  Box,
  Image,
  useBreakpointValue,
  VStack,
  Text,
  Flex } from
"@chakra-ui/react";
import wall_images from "../../../utils/wall/wall-imges";
import { PlainInputStyles } from "./PlainInputStyles";
import SuggestionBox from "../Doubt/SuggestionBox";
import { StorageService } from "../../../utils/StorageUtils";
import ImageTranscription from "./ImageTranscription";
import pkg from "@inrscr/coschool-ui-components";

export default function PlainInput({
  isDisable = false,
  hideFormula = false,
  handleSubmit,
  buttons = {},
  onMenuToggle,
  chatHistory,
  onResetClick,
  displayedQues,
  onNewChapterClick,
  handleNextQuestionClick,
  handleFeedBackClick,
  displaySubmit,
  handleSubmitClick,
  handleButtonActionsInDoubt,
  resetPractice,
  openMenu,
  currentQues
}) {
  const containerRef = useRef(null);
  const bottomNavRef = useRef(null);
  const [inputValue, setInputValue, inputValueRef] = useStateRef("");
  const [isSubmitted, setIsSubmitted, isSubmittedRef] = useStateRef(false);
  const [isToastOpen, setIsToastOpen, isToastOpenRef] = useStateRef(false);
  const [description, setDescription, descriptionRef] = useStateRef("");
  const [contextIndex, setContextIndex, contextIndexRef] = useStateRef();
  const [backUpObject, setBackUpObject, backUpObjectRef] = useStateRef(null);

  const {
    selectedIndex,
    setSelectedIndex,
    topicName,
    subTopicName,
    isStandalone,
    isReviewScreen,
    setReviewScreen,
    isTutor,
    setHandleTakeupNextTask,
    setTaskId,
    isRedirectObjectInserted,
    isStudentAppMapping,
    taskType,
    isUpdatesDisplayed,
    setIsUpdatesDisplayed,
    isDiscussFlow,
    setIsDiscussFlow,
    displayProductTour
  } = useRoot();

  const buttonSize = useBreakpointValue({
    base: "small", // Extra small on mobile
    sm: "small", // Small on small screens
    md: "small", // Medium on medium screens
    lg: "small", // Large on large screens
    xl: "medium" // Extra large on extra large screens
  });
  // const { learningStepData, setLearningStepData } = usePractice();
  const {
    taskStatus,
    setIsTaskCompleted,
    setOnNextItemSelected,
    setOverAllQuestionResult,
    setAnswerCount,
    setJourneyId,
    journeyId,
    setTaskStepId,
    isFeedbackSubmitted,
    setTopic,
    setSubtopicId,
    selectedSubTopic,
    selectedTopic,
    isOCREnabled
  } = useTutor();

  const {
    showHintBtn,
    showConcludeBtn,
    showNextBtn,
    isLastQues,
    showFeedBack,
    switchContext,
    showEndConv,
    showPocketBtn,
    isOutOfTopic,
    showNextBtnForFactual,
    showTryAnotherQuesBtn,
    handleDoubtFlow,
    seeConversationBtn
  } = buttons;
  const {
    hint,
    conclude,
    nextQuestion,
    endSession,
    feedback,
    submit,
    contextSwitch,
    stayHere,
    selectAnotherTopic,
    continueConversation,
    anotherDoubt,
    sendToPocket,
    tryAnotherQues,
    clarificationBtnText,
    seeConversation
  } = BOTTOM_BUTTONS;
  const isMobile = useBreakpointValue({
    base: true,
    md: false,
    lg: false
  });
  const { topic, userQuery, setUserQuery } = useTutor();
  const { isEnableSubmitBtn = false, allowToEnter = false } = buttons;
  const [buttonsObj, setButtonsObj, buttonsObjRef] = useStateRef([]);
  const { BottomNav, CustomButton, StudentEditor } = pkg;
  const [isMenuNavOpen, setIsMenuNavOpen] = useState(false);
  const [redirectFlag, setRedirectFlag] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const DEBOUNCE_DELAY = 500; // Adjust this value based on your needs
  const isClickable = useRef(true);
  const timeoutRef = useRef(null);
  const location = useLocation();
  useEffect(() => {
    const value = StorageService.getItem("redirectObject");
    if (value) {
      setRedirectFlag(true);
    }
  }, [isRedirectObjectInserted]);

  useEffect(() => {
    const storedBackUp = StorageService.getItem("backUpObject");
    if (isNotEmptyOrNull(storedBackUp)) {
      setBackUpObject(storedBackUp);
    }
  }, []);

  useEffect(() => {
    if (!isMenuNavOpen) return;

    function handleClickOutside(event) {
      const isClickOutsideMenu =
      !event.target.closest(".bottom-nav-wrapper") &&
      !event.target.closest('[data-menu-trigger="true"]');

      if (isClickOutsideMenu && isMenuNavOpen) {
        setIsMenuNavOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuNavOpen]);

  const setButtons = () => {
    setButtonsObj(() => {
      const updatedButtons = [];

      if (!isLastQues && showHintBtn && selectedIndex !== 5) {
        updatedButtons.push({
          buttonText: hint,
          buttonType: "Secondary",
          state: "Enabled",
          size: buttonSize
        });
      }

      if (showConcludeBtn && selectedIndex !== 5) {
        updatedButtons.push({
          buttonText: conclude,
          buttonType: "Secondary",
          state: "Enabled",
          size: buttonSize
        });
      }

      if ((showFeedBack || showPocketBtn) && isStandalone) {
        updatedButtons.push({
          buttonText: feedback,
          buttonType: "Secondary",
          state: isFeedbackSubmitted ? "Disabled" : "Enabled",
          size: buttonSize
        });
      }

      if (showTryAnotherQuesBtn) {
        updatedButtons.push({
          buttonText: tryAnotherQues,
          buttonType: "Primary",
          state: !isFeedbackSubmitted && isStandalone ? "Disabled" : "Enabled",
          size: buttonSize,
          isDisabled: !isFeedbackSubmitted && isStandalone
        });
      }

      if (showNextBtn || showNextBtnForFactual) {
        updatedButtons.push({
          buttonText: nextQuestion,
          buttonType: "Primary",
          state: showNextBtnForFactual ?
          "Enabled" :
          !isFeedbackSubmitted && isStandalone && !isLastQues ?
          "Disabled" :
          "Enabled",
          size: buttonSize
        });
      }

      if (isLastQues) {
        updatedButtons.push({
          buttonText: endSession,
          buttonType: "Secondary",
          state: "Enabled",
          size: buttonSize
        });
      }

      if (displaySubmit) {
        updatedButtons.push({
          buttonText: submit,
          buttonType: "Secondary",
          state: "Enabled",
          size: buttonSize
        });
      }

      if (switchContext) {
        updatedButtons.push({
          buttonText: continueConversation,
          buttonType: "Secondary",
          state: "Enabled",
          size: buttonSize
        });
      }

      if (showEndConv) {
        updatedButtons.push({
          buttonText: getConcludeBtnText(buttons?.doubtState),
          buttonType: "Secondary",
          state: "Enabled",
          size: buttonSize
        });
      }
      if (buttons?.needClarification && selectedIndex === 2) {
        updatedButtons.push({
          buttonText: clarificationBtnText,
          buttonType: "Secondary",
          state: "Enabled",
          size: buttonSize
        });
      }

      if (showPocketBtn && isStandalone) {
        updatedButtons.push({
          buttonText: anotherDoubt,
          buttonType: "Secondary",
          state: !isFeedbackSubmitted && isStandalone ? "Disabled" : "Enabled",
          size: buttonSize
        });
      }

      if (showPocketBtn) {
        updatedButtons.push({
          buttonText: sendToPocket,
          buttonType: "Secondary",
          state: !isFeedbackSubmitted && isStandalone ? "Disabled" : "Enabled",
          size: buttonSize
        });
      }

      if (isOutOfTopic) {
        updatedButtons.push({
          buttonText: selectAnotherTopic,
          buttonType: "Secondary",
          state: "Enabled",
          size: buttonSize
        });
        updatedButtons.push({
          buttonText: continueConversation,
          buttonType: "Secondary",
          state: "Enabled",
          size: buttonSize
        });
      }

      if (seeConversationBtn) {
        updatedButtons.push({
          buttonText: seeConversation,
          buttonType: "Primary",
          state: "Enabled",
          size: buttonSize
        });
      }

      return updatedButtons;
    });
  };
  const navigate = useNavigate();
  let icons = {
    menuBoard: MenuBoard,
    addChapter: AddChapter,
    addTopic: AddTopic
  };

  // updated styles based on conditions
  const blockEditor = isDisable;
  const containerStyle = `input-container ${
  blockEditor || !allowToEnter ? "block-editor" : ""}`;

  let submitBtnStyle = `submit-img `;
  if (blockEditor) {
    submitBtnStyle += "block-editor ";
  }
  if (!isEnableSubmitBtn) {
    submitBtnStyle += "disable";
  }

  useEffect(() => {
    if (containerRef?.current) {
      containerRef.current.focus();
    }
    setIsClient(true);
    return () => {};
  }, [isMobile]);
  const blurFocusedElement = () => {
    const focusedElement = containerRef.current.querySelector(":focus");
    if (focusedElement) {
      focusedElement.blur();
    }
  };

  const handleSend = (customData, images) => {
    handleSubmit(customData, images);
    setInputValue("");
    setIsSubmitted(false);
    blurFocusedElement();
  };

  const getSchoolAiBottomList = () => {
    const isSelfStudyActive = selectedIndex === 6;

    const isClassUpdatesActive = selectedIndex === 0 && isUpdatesDisplayed;

    const isHomeworkActive = selectedIndex === 0 && !isUpdatesDisplayed;

    return [
    {
      icon: isHomeworkActive ?
      wall_images.tasksBold :
      wall_images.tasksOutline,
      title: "Homework",
      index: 0,
      isActive: isHomeworkActive
    },
    {
      icon: isClassUpdatesActive ?
      wall_images.schoolUpdatesBold :
      wall_images.syllabusOutline,
      title: "Class Updates",
      index: 0,
      isActive: isClassUpdatesActive
    },
    {
      icon: isSelfStudyActive ?
      wall_images.syllabusBold :
      wall_images.schoolUpdatesOutline,
      title: "Self Study",
      index: 6,
      isActive: isSelfStudyActive
    }];

  };

  const schoolAiBottomList = getSchoolAiBottomList();

  const mobileBottomList = [
  {
    icon:
    selectedIndex === 0 && !isUpdatesDisplayed ?
    wall_images.tasksBold :
    wall_images.tasksNormal,
    title: "Homework",
    index: 0,
    isActive: selectedIndex === 0 && !isUpdatesDisplayed ? true : false
  },
  {
    icon:
    selectedIndex === 0 && isUpdatesDisplayed ?
    wall_images.schoolUpdatesBold :
    wall_images.schoolUpdatesNormal,
    title: "Class Updates",
    index: 0,
    isActive: selectedIndex === 0 && isUpdatesDisplayed ? true : false
  },
  {
    icon:
    selectedIndex !== 0 ?
    wall_images.syllabusBold :
    wall_images.syllabusNormal,
    title: "Self Study",
    index: 6,
    isActive: selectedIndex !== 0 ? true : false
  }];


  const tutorBottomList = isStudentAppMapping ?
  [
  {
    title: "Practice",
    index: 3
  }] :

  [
  {
    title: "Practice",
    index: 3
  },
  {
    title: "Doubt",
    index: 2
  }];


  const checkContext = (index) => {
    setContextIndex(index);
    if (
    !isReviewScreen && (
    selectedIndex === 2 ?
    isNotEmptyOrNull(chatHistory) :
    isNotEmptyOrNull(displayedQues)))
    {
      setIsToastOpen(true);
      setDescription(
        "We're shifting contexts now. When you return to " + (
        selectedIndex === 0 ?
        "home" :
        selectedIndex === 1 ?
        "learn" :
        selectedIndex === 2 ?
        "doubt" :
        selectedIndex === 3 ?
        "practice" :
        selectedIndex === 4 ?
        "practice" :
        "assessment") +
        " later, we'll need to begin anew. Feel free to continue if you have any specific questions related to the current context."
      );
      const updatedButtons = [];

      updatedButtons.push({
        buttonText: contextSwitch,
        buttonType: "Secondary",
        state: "Enabled",
        size: buttonSize
      });
      updatedButtons.push({
        buttonText: stayHere,
        buttonType: "Primary",
        state: "Enabled",
        size: buttonSize
      });
      setButtonsObj(updatedButtons);
    } else {
      setIsToastOpen(false);
      setDescription("");
      handleRoute(index);
      if (selectedIndex !== index && isReviewScreen) {
        onNewChapterTopicClick();
      }
      setSelectedIndex(index);
    }
    setReviewScreen(false);
  };

  useEffect(() => {
    if (isReviewScreen) {
      setButtonsObj([]);
    }
  }, [isReviewScreen]);

  const handleRoute = (index, contextSwitch) => {
    if (contextSwitch) {
      StorageService.removeItem("backUpObject");
      StorageService?.removeItem("assesmentInfo");
      setIsDiscussFlow(false);
      resetPractice();
    }
    setIsMenuNavOpen(!isMenuNavOpen);
    if (index == 0) {
      navigate(`${urlString}/home`, { replace: true });
    } else if (index == 1) {
      navigate(`${urlString}/learn`);
    } else if (index == 2) {
      navigate(`${isTutor ? tutorString : urlString}/doubt`);
    } else if (index == 3) {
      navigate(`${tutorString}/practice`);
    } else if (index == 4) {
      navigate(`${urlString}/practice`);
    } else if (index == 5) {
      navigate(`${urlString}/assessment`);
    } else if (index == 6) {
      navigate(`${urlString}/syllabus`);
    }
  };

  useEffect(() => {
    setIsToastOpen(false);
    setButtonsObj([]);
    setButtons();
    if (buttons?.clearAllBottomButtons) {
      setButtonsObj([]);
    }
  }, [buttons, displaySubmit]);

  const handleClick = (selectedItem) => {
    let index = selectedItem?.index;

    if (selectedIndex === 0 && selectedItem?.title === "Homework") {
      setIsUpdatesDisplayed(false);
    } else if (selectedIndex === 0 && selectedItem?.title === "Class Updates") {
      setIsUpdatesDisplayed(true);
    } else if (selectedIndex !== 0) {
      if (selectedItem?.title === "Class Updates") {
        setIsUpdatesDisplayed(true);
      } else {
        setIsUpdatesDisplayed(false);
      }
    }
    if (
    selectedIndex !== index && (
    isNotEmptyOrNull(topicName) || isNotEmptyOrNull(subTopicName)) &&
    !isStandalone &&
    !isReviewScreen)
    {
      // setAlertFlag((alertFlag) => !alertFlag);
      checkContext(index);
    } else {
      checkContext(index);
    }
    setReviewScreen(false);
    // handleRoute(index);
    // setSelectedIndex(index);
  };

  const onButtonClick = (input) => {
    // If button is not clickable, return early
    if (!isClickable.current) return;

    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Disable clicking
    isClickable.current = false;
    switch (input) {
      case hint:
        buttons?.handleHintClick && buttons?.handleHintClick();
        setInputValue("");
        break;
      case conclude:
        if (selectedIndex == 2) {
          handleButtonActionsInDoubt(input);
        } else {
          buttons?.handleConclude && buttons?.handleConclude();
          setInputValue("");
        }
        break;
      case nextQuestion:
      case endSession:
        handleNextQuestionClick();
        break;
      case getConcludeBtnText(buttons?.doubtState):
        handleButtonActionsInDoubt(input);
        break;
      case feedback:
        if (selectedIndex !== 2) {
          handleFeedBackClick();
        } else {
          handleButtonActionsInDoubt(input);
        }
        break;
      case tryAnotherQues:
        buttons?.handleTryAnotherQues && buttons?.handleTryAnotherQues();
        setInputValue("");
        break;
      case submit:
        handleSubmitClick();
        break;
      case contextSwitch:
        setButtonsObj([]);
        setIsToastOpen(false);
        handleRoute(contextIndexRef.current, true);

        break;
      case stayHere:
        setButtonsObj([]);
        setButtons();
        setIsToastOpen(false);
        break;
      default:
        if (selectedIndex === 2) {
          handleButtonActionsInDoubt(input);
        }
        break;
    }
    timeoutRef.current = setTimeout(() => {
      isClickable.current = true;
      timeoutRef.current = null;
    }, DEBOUNCE_DELAY);
  };

  useEffect(() => {
    if (onMenuToggle) {
      setIsMenuNavOpen(!isMenuNavOpen);
    }
  }, [onMenuToggle]);

  const onNewChapterTopicClick = (input) => {
    setButtonsObj([]);
    setIsToastOpen(false);
    setInputValue("");
    setIsMenuNavOpen(false);
    if (selectedIndex === 3) {
      onNewChapterClick();
    } else {
      if (typeof onResetClick === "function") {
        onResetClick();
      }
      setOverAllQuestionResult({});
      setAnswerCount();
      setTaskStepId("");
      setTaskId("");
      setIsTaskCompleted(false);
      setJourneyId("");
      buttons?.setDisplayedQues([]);
      buttons?.setCurrentQuestionIndex(0);
      buttons?.setQuestions([]);
      buttons?.setChatHistory([]);
      buttons?.setChatQuery("");
      setSubtopicId("");
      setTopic("");
      setHandleTakeupNextTask(true);
      // setLearningStepData([]);
    }
  };

  const handleClickSubmit = (data) => {
    if (isEnableSubmitBtn || data?.trim()?.length > 0) {
      handleSend(data);
    }
  };
  const handleImageToText = (data, images) => {
    handleSend(data, images);
  };

  if (!isClient) {
    return null;
  }

  return (
    <Box>
      {/** Added buttton "Back To Preview" */}
      {buttons?.showBackToPreview &&
      location?.pathname?.includes("practice") &&
      <Box sx={PlainInputStyles()?.backToPreview}>
            <CustomButton
          label={"Back to review"}
          handleClick={() => {
            setIsDiscussFlow(false);
            navigate(-1);
          }}
          image={ArrowLeft}
          customStyles={PlainInputStyles()?.backToPreviewCustomStyles} />

          </Box>
      }
      <Box
        ml={{
          base: isMobile && isNotEmptyOrNull(selectedSubTopic) ? "8%" : "0%",
          md: "6%",
          lg: "0%",
          xl: "0%"
        }}
        py={2}>

        {chatHistory?.length == 0 &&
        selectedIndex === 2 &&
        window?.ENV?.ENABLE_SUGGESTIONS == "true" &&
        <SuggestionBox
          handleDoubtFlow={handleDoubtFlow}
          onReset={() => {
            setInputValue("");
            setUserQuery("");
          }} />

        }
        {displayProductTour &&
        <>
            {!isMobile ?
          <>
                <div
              id="menuIcon1"
              style={{
                width: "14%",
                marginTop: "16px",
                marginLeft: "16px"
              }}>

                  {openMenu &&
              <VStack
                width="100%"
                display="flex"
                alignItems="flex-start"
                backgroundColor={"#fff"}
                borderTopLeftRadius="8px"
                borderTopRightRadius="8px"
                borderTop={"1px solid #E4E4E7"}
                borderLeft={"1px solid #E4E4E7"}
                borderRight={"1px solid #E4E4E7"}
                padding={"8px 16px"}
                margin="0">

                      <Box
                  width="100%"
                  padding={"8px 16px"}
                  maxWidth="max-content"
                  height="max-content"
                  cursor="pointer"
                  backgroundColor="#fff"
                  borderRadius={"8px"}
                  _hover={{
                    bgColor: "#FFDFDB"
                  }}>

                        <Flex gap={"8px"}>
                          <Image
                      src={wall_images.tasksOutline}
                      width={"24px"}
                      height={"24px"} />

                          <Box width="max-content" height={"max-content"}>
                            <Text
                        fontFamily="Poppins"
                        fontWeight={400}
                        fontSize={"14px"}
                        lineHeight="21px"
                        textAlign={"left"}
                        color="#21146D"
                        width="max-content">

                              {"Homework"}
                            </Text>
                          </Box>
                        </Flex>
                      </Box>
                    </VStack>
              }
                </div>
                <div
              id="menuIcon2"
              style={{ width: "14%", marginLeft: "16px" }}>

                  {openMenu &&
              <VStack
                width="100%"
                display="flex"
                alignItems="flex-start"
                backgroundColor={"#fff"}
                borderLeft={"1px solid #E4E4E7"}
                borderRight={"1px solid #E4E4E7"}
                padding={"8px 16px"}
                margin="0">

                      <Box
                  width="100%"
                  padding={"8px 16px"}
                  maxWidth="max-content"
                  height="max-content"
                  cursor="pointer"
                  backgroundColor="#fff"
                  borderRadius={"8px"}
                  _hover={{
                    bgColor: "#FFDFDB"
                  }}>

                        <Flex gap={"8px"}>
                          <Image
                      src={wall_images.schoolUpdatesOutline}
                      width={"24px"}
                      height={"24px"} />

                          <Box width="max-content" height={"max-content"}>
                            <Text
                        fontFamily="Poppins"
                        fontWeight={400}
                        fontSize={"14px"}
                        lineHeight="21px"
                        textAlign={"left"}
                        color="#21146D"
                        width="max-content">

                              {"Class Updates"}
                            </Text>
                          </Box>
                        </Flex>
                      </Box>
                    </VStack>
              }
                </div>
                <div
              id="menuIcon3"
              style={{
                width: "14%",
                marginBottom: "16px",
                marginLeft: "16px"
              }}>

                  {openMenu &&
              <VStack
                width="100%"
                display="flex"
                alignItems="flex-start"
                backgroundColor={"#fff"}
                borderBottomLeftRadius="8px"
                borderBottomRightRadius="8px"
                borderLeft={"1px solid #E4E4E7"}
                borderRight={"1px solid #E4E4E7"}
                borderBottom={"1px solid #E4E4E7"}
                padding={"8px 16px"}
                margin="0">

                      <Box
                  width="100%"
                  padding={"8px 16px"}
                  maxWidth="max-content"
                  height="max-content"
                  cursor="pointer"
                  backgroundColor="#fff"
                  borderRadius={"8px"}
                  _hover={{
                    bgColor: "#FFDFDB"
                  }}>

                        <Flex gap={"8px"}>
                          <Image
                      src={wall_images.syllabusOutline}
                      width={"24px"}
                      height={"24px"} />

                          <Box width="max-content" height={"max-content"}>
                            <Text
                        fontFamily="Poppins"
                        fontWeight={400}
                        fontSize={"14px"}
                        lineHeight="21px"
                        textAlign={"left"}
                        color="#21146D"
                        width="max-content">

                              {"Self Study"}
                            </Text>
                          </Box>
                        </Flex>
                      </Box>
                    </VStack>
              }
                </div>
              </> :

          <Flex
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            gap={"32px"}>

                <Flex
              id="menuIcon1"
              direction="column"
              alignItems="center"
              paddingY={"8px"}
              cursor="pointer"
              marginLeft={"30px"}
              onClick={() => {}}
              gap={"6px"}>

                  <Box
                width="24px"
                height="24px"
                display="flex"
                justifyContent="center"
                alignItems="center">

                    <Image
                  src={wall_images.tasksOutline}
                  width="24px"
                  height="24px"
                  alt="Centered Image" />

                  </Box>

                  <Box width="max-content">
                    <Text
                  fontWeight={400}
                  fontFamily={"Poppins"}
                  fontSize={"12px"}
                  lineHeight="18px"
                  textAlign={"center"}
                  color={"#5F4DC7"}
                  whiteSpace="nowrap">

                      Homework
                    </Text>
                  </Box>
                </Flex>
                <Flex
              id="menuIcon2"
              direction="column"
              alignItems="center"
              paddingY={"8px"}
              cursor="pointer"
              onClick={() => {}}
              gap={"6px"}>

                  <Box
                width="24px"
                height="24px"
                display="flex"
                justifyContent="center"
                alignItems="center">

                    <Image
                  src={wall_images.schoolUpdatesOutline}
                  width="24px"
                  height="24px"
                  alt="Centered Image" />

                  </Box>

                  <Box width="max-content">
                    <Text
                  fontWeight={400}
                  fontFamily={"Poppins"}
                  fontSize={"12px"}
                  lineHeight="18px"
                  textAlign={"center"}
                  color={"#A299D4"}
                  whiteSpace="nowrap">

                      Class Updates
                    </Text>
                  </Box>
                </Flex>
                <Flex
              id="menuIcon3"
              direction="column"
              alignItems="center"
              paddingY={"8px"}
              cursor="pointer"
              marginRight={"30px"}
              onClick={() => {}}
              gap={"6px"}>

                  <Box
                width="24px"
                height="24px"
                display="flex"
                justifyContent="center"
                alignItems="center">

                    <Image
                  src={wall_images.syllabusOutline}
                  width="24px"
                  height="24px"
                  alt="Centered Image" />

                  </Box>

                  <Box width="max-content">
                    <Text
                  fontWeight={400}
                  fontFamily={"Poppins"}
                  fontSize={"12px"}
                  lineHeight="18px"
                  textAlign={"center"}
                  color={"#A299D4"}
                  whiteSpace="nowrap">

                      Self Study
                    </Text>
                  </Box>
                </Flex>
              </Flex>
          }
          </>
        }
        {!displayProductTour &&
        <div className="bottom-nav-wrapper">
            <BottomNav
            data-testid="bottom-nav-button"
            ref={bottomNavRef}
            navMenuList={
            isTutor ?
            tutorBottomList :
            location.pathname.includes("/doubt") ||
            location.pathname.includes("/review") ||
            isStandalone ||
            isDiscussFlow ||
            isNotEmptyOrNull(backUpObjectRef?.current) ?
            schoolAiBottomList :
            !(isMobile && isEmptyOrNull(selectedSubTopic)) ?
            schoolAiBottomList :
            mobileBottomList
            }
            onNavMenuClick={(selectedItem) => {
              handleClick(selectedItem);
              setIsMenuNavOpen(false);
            }}
            buttonArray={
            isMenuNavOpen ?
            [] :
            isNotEmptyOrNull(buttonsObjRef?.current) ?
            buttonsObjRef.current :
            []
            }
            icons={icons}
            description={descriptionRef.current}
            handleClose={() => {
              setIsToastOpen(false);
              setButtonsObj([]);
              setButtons();
            }}
            isToastOpen={isMenuNavOpen ? false : isToastOpenRef.current}
            buttonClick={onButtonClick}
            isBottomNavButtonsOpen={true}
            isMobileView={isMobile}
            isMenuOpen={
            location.pathname.includes("/doubt") ||
            location.pathname.includes("/review") ||
            isStandalone ||
            isDiscussFlow ||
            isNotEmptyOrNull(backUpObjectRef?.current) ?
            isMenuNavOpen :
            isMobile && isEmptyOrNull(selectedSubTopic) ?
            true :
            // : isToastOpenRef?.current
            // ? false
            isMenuNavOpen
            }
            isNewBottomList={
            location.pathname.includes("/doubt") ||
            location.pathname.includes("/review") ||
            isStandalone ||
            isDiscussFlow ||
            isNotEmptyOrNull(backUpObjectRef?.current) ?
            false :
            isMobile && isEmptyOrNull(selectedSubTopic) ?
            true :
            false
            } />

          </div>
        }
      </Box>
      {(!(isMobile && isEmptyOrNull(selectedSubTopic)) ||
      location.pathname.includes("/doubt") ||
      location.pathname.includes("/review") ||
      isStandalone ||
      isDiscussFlow ||
      isNotEmptyOrNull(backUpObjectRef?.current)) &&
      <Box sx={PlainInputStyles()?.parentEditableDiv}>
          {!redirectFlag &&
        <Box sx={PlainInputStyles()?.menuImageContainer}>
              <Image
            sx={PlainInputStyles()?.menuImage}
            data-menu-trigger="true" // Add this attribute
            src={MenuIcon}
            onClick={() => {
              setIsMenuNavOpen(!isMenuNavOpen);
            }} />

            </Box>
        }
          <Box
          sx={
          location.pathname.includes("/review") ?
          PlainInputStyles()?.containerInputReview :
          PlainInputStyles(blockEditor, allowToEnter)?.containerInput
          }
          ref={containerRef}>

            <Box w={"100%"} ml={0} position={"relative"}>
              <StudentEditor
              disablePaste={isStandalone ? false : true}
              data={inputValue}
              handleChange={(val) => {
                setInputValue(val);
                setUserQuery(val);
              }}
              onSubmit={(data) => {
                handleClickSubmit(data);
              }}
              icons={{
                submit: SubmitImg,
                formula: Formula
              }}
              isDisabled={blockEditor || !allowToEnter}
              addImageRender={
              buttons?.isDescAnsQues && isOCREnabled ?
              () =>
              <ImageTranscription
                onClick={handleImageToText}
                chatId={buttons?.chatId}
                currentQues={currentQues} /> :


              undefined
              } />

            </Box>
          </Box>
        </Box>
      }
    </Box>);

}